/**
 * Single source of truth for die-set code prefixes used across the backend
 * MCP validator, the WebUI proposal card, and the `buildProductCode`
 * utility.
 *
 * Two sets — different scopes:
 *
 *   `VALIDATABLE_DIE_SET_PREFIXES` — the full set accepted by prefix
 *     validators (LLM-supplied `productCode` regex check + WebUI card
 *     inline validation). Includes `SPL` for the special-shape escape
 *     hatch where the admin supplies the code directly.
 *
 *   `BUILDABLE_DIE_SET_PREFIXES` — the strict subset `buildProductCode`
 *     can ENCODE dimensions for. `SPL` is excluded because the special
 *     format does not carry dimensional digits; trying to build an `SPL-`
 *     code from `(verticalIn, horizontalIn)` is a programmer error.
 *
 * Adding a new prefix → update `VALIDATABLE_…`. If the new prefix carries
 * dimensions, also add it to `BUILDABLE_…`. Both sets cascade through one
 * regex + one validator + one builder.
 */

export const VALIDATABLE_DIE_SET_PREFIXES = [
  'DD',
  'DDH',
  'SDD',
  'SGDD',
  'MD',
  'RD',
  'RDS',
  'SPL',
] as const

export const BUILDABLE_DIE_SET_PREFIXES = [
  'DD',
  'DDH',
  'SDD',
  'SGDD',
  'MD',
  'RD',
  'RDS',
] as const

/**
 * Compiled regex of `^(<prefix>|…)-`. Used by the backend MCP tool to
 * validate LLM-supplied `productCode` overrides before falling back to
 * dimension-derived generation.
 */
export const VALID_PRODUCT_CODE_PREFIX_REGEX = new RegExp(
  `^(${VALIDATABLE_DIE_SET_PREFIXES.join('|')})-`
)
